import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

type Body = Record<string, unknown>;
export type RouteResult = { changed: boolean; destinations?: unknown[]; startDate?: string; endDate?: string };
export type RouteRequest = { tripId: string; branchId?: string } & (
  { action: 'edit'; before: Body; after: Body } |
  { action: 'append'; destinations: Body[]; matching: 'exact' | 'arrival' } |
  { action: 'remove'; destination: Body; previous: { destinations: Body[]; startDate?: string; endDate?: string } }
);

/**
 * Change a trip's route (destinations and trip dates) through the server, which
 * validates it against every traveller's branches, including ones this client
 * can't read (functions/src/tripRoute.ts).
 *
 * Returns false only while the function isn't deployed/reachable, so callers can
 * fall back to their old direct write for that rollout window. Once the rules
 * refuse direct route writes that fallback fails closed, and this is the only
 * path. Real answers (refused, invalid, rate limited) are thrown.
 */
export async function changeTripRoute(request: RouteRequest): Promise<RouteResult | false> {
  try {
    const call = httpsCallable<RouteRequest, RouteResult>(functions, 'changeTripRoute');
    return (await call(request)).data;
  } catch (err) {
    const code = (err as { code?: string })?.code ?? '';
    if (/not-found|unavailable|internal|unimplemented/.test(code)) return false;
    throw err;
  }
}
